module.exports = __webpack_public_path__ + "static/media/background.4666e1a7.png";